import { FC } from 'react'
import dynamic from 'next/dynamic'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import lottie from './lottie.json'
import * as S from './styles'
import { FeaturedProps } from '../types'

// Load Lottie-Component only in case of client side rendering (exclude SSR)
const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, description }) => (
  <S.Featured>
    <Row>
      <Col className='feat-breadcumb'>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col xs='12' xl='7'>
        <S.BannerLeft>
          <Text
            as='h1'
            size='xxlg'
            className='banner-header-primary'
            family='text'
            weight='semiBlack'
            margin='0 0 1.5rem 0'
            itemProp='name'
          >
            {title}
          </Text>
          <span dangerouslySetInnerHTML={{ __html: description }}></span>
        </S.BannerLeft>
      </Col>
      <Col xs='12' xl='5'>
        <S.LottieSet>
          <Lottie animationData={lottie} loop={true} />
        </S.LottieSet>
      </Col>
    </Row>
  </S.Featured>
)
